module.exports = __webpack_public_path__ + "static/media/likeHover.55ce8bcd.svg";